<!--  -->
<template>
    <div v-if="isShow && article && article.image">
        <div v-if="!article.url" class="prelative sundiv cpointer" @mouseover="_imgOver" @mouseout="addTime" ref="sundiv">
            <span @click="_dieTime" class="iconfont icon-guanbi1"></span>
            <img :src="article.image" width="300" alt="">
        </div>
        <div v-else class="prelative sundiv cpointer" @mouseover="_imgOver" @mouseout="addTime" ref="sundiv">
            <span @click="_dieTime" class="iconfont icon-guanbi1"></span>
            <img :src="article.image" width="200" alt="" @click="()=>openNew(article.url)">
        </div>
    </div>
</template>

<script>
export default {
    name: 'demo',
    data() {
        return {
            directX: 1,//x轴的方向
            directY: 1,//y轴的方向
            //上面两个全局变量似乎没有生效
            sunX: 0,//小太阳的坐标x
            sunY: 0,//小太阳的坐标y
            timeId: null,
            sundiv: null,
            isShow: 1,
            //article: null
        }
    },
    props: {
        article: {
            type: Object,
            default: null
        },
    },
    created(){
        console.log('------------')
        console.log(this.article)
        //this.getArticle()
    },
    mounted() {
        this.$nextTick(() => {
            if(this.$refs.sundiv){
                this.sundiv = this.$refs.sundiv
                this.addTime()
            }
                
        })
    },
    activated() {
        this.addTime()
    },
    deactivated() {
        this.clearTime()
    },
    beforeDestroy(){
        this.clearTime()
    },
    methods: {
        openNew(url) {
            window.open(url, '_blank');
        },
        _goDetail(){
            let path = this.$params.baseDir + 'news/sdetail/' + this.article.id
            this.$router.push({
                path
            })
        },
        _dieTime(){
            this.clearTime()
            this.isShow = false
            this.sundiv = null
        },
        _imgOver() {
            this.clearTime()
        },
        addTime() {
            if(!this.sundiv)
                return
            this.timeId = setInterval(this.sunMove, 20);
        },
        clearTime() {
            clearInterval(this.timeId)
            this.timeId = null
        },
        sunMove() {
            let sundiv = this.sundiv
            this.sunX += this.directX;
            this.sunY += this.directY;
            //这条语句无法执行，竟然是因为<!doctype html>存在

            //修改div的left top
            sundiv.style.top = this.sunY + "px";
            //window.alert(this.sunY);
            //window.alert(sundiv.style.top);
            sundiv.style.left = this.sunX + "px";
            //判断什么时候，转变方法
            //x方法（offsetWidth可以返回当前这个对象的实际宽度）
            // console.log(document.documentElement.scrollTop )
            // console.log(document.documentElement.clientHeight)
            // return 
            if (this.sunX + sundiv.offsetWidth >= document.documentElement.clientWidth - 20 || this.sunX <= 0) {
                //window.alert(this.directX);
                //this.directX-=this.directX;
                this.directX = -this.directX;
            }
            //判断y
            let scrollTop = document.documentElement.scrollTop 
            let clientHeight = document.documentElement.clientHeight
            if (this.sunY <= scrollTop){
                // alert(this.directY)
                this.directY = Math.abs(this.directY)
                this.sunY = scrollTop + 2
            }else if (this.sunY + sundiv.offsetHeight >= scrollTop + clientHeight || this.sunY <= 0) {
                //this.directY-=this.directY;
                this.directY = - Math.abs(this.directY)
                //window.alert(this.directY);
            }
        },
        getArticle() {
            this.$request.get('article/first-article-by-type', { type: 17 }, res => {
                if (res.data.code == 200) {
                    this.article = res.data.data
                }
            }, err => {
                console.log(err)
            })
        }
    },
}
</script> 

<style lang='less' scoped>
.sundiv {
    position: absolute;
    z-index: 999;
}

.icon-guanbi1 {
    position: absolute;
    right: -21px;
    top: -21px;
    color: #666;
    font-size: 28px;
}
.icon-guanbi1:hover{
    color: red;
    transition: all 1s;
    transform: rotate(270deg)
}
</style>
